/**
 * Donator types.
 */
export enum DonatorType {
  New = 'new',
  Returning = 'returning',
  Anonymous = 'anonymous',
}
